import React from 'react';
import { Drawer, AppBar, Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MenuListComponent from '../MenuListComponent';
import { WHITE_TEXT } from '../../color';
import { useStyles } from './InternalStyle';
import ToolbarCompnent from '../Toolbar/ToolbarComponent';

export default function BarsOverlay(props) {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'), {
    noSsr: true,
  });
  const {
    roles,
    isAdmin,
    setIsAdmin,
    reportsSelected,
    setReportsSelected,
    HRSelected,
    setHRSelected,
    financeSelected,
    setFinanceSelected,
    seniorManagerSelected,
    setSeniorManagerSelected,
    techCouncilSelected,
    setTechCouncilSelected,
    projectAdminSelected,
    setProjectAdminSelected,
  } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar position="fixed" sx={{ width: `100%`, background: WHITE_TEXT }}>
        <ToolbarCompnent
          roles={roles}
          open={mobileOpen}
          setOpen={setMobileOpen}
          isAdmin={isAdmin}
          setIsAdmin={setIsAdmin}
          reportsSelected={reportsSelected}
          setReportsSelected={setReportsSelected}
          HRSelected={HRSelected}
          setHRSelected={setHRSelected}
          financeSelected={financeSelected}
          setFinanceSelected={setFinanceSelected}
          seniorManagerSelected={seniorManagerSelected}
          setSeniorManagerSelected={setSeniorManagerSelected}
          techCouncilSelected={techCouncilSelected}
          setTechCouncilSelected={setTechCouncilSelected}
          projectAdminSelected={projectAdminSelected}
          setProjectAdminSelected={setProjectAdminSelected}
        />
      </AppBar>
      {roles.length > 0 &&
        (isMobile ? (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            sx={{
              display: { xs: 'block', sm: 'none' },
              '& .MuiDrawer-paper': { marginTop: '4em' },
            }}
            className={classes.permanentDrawer}
          >
            <MenuListComponent
              hideMenu={setMobileOpen}
              sideMenuRoutes={props.sideMenuRoutes}
            />
          </Drawer>
        ) : (
          <Drawer
            sx={{
              display: { xs: 'none', sm: 'block' },
              '& .MuiDrawer-paper': { marginTop: '5em' },
            }}
            className={classes.permanentDrawer}
            variant="permanent"
            anchor="left"
          >
            <MenuListComponent sideMenuRoutes={props.sideMenuRoutes} />
          </Drawer>
        ))}
    </Box>
  );
}
